import * as React from 'react';
import { translate } from 'react-i18next';
import { AppContext } from '@src/context/store';
import { isAppEnabled, getLiveSiteUrl, getKBLinks } from '@src/context/selectors/ui-settings';
import { SaveAndPublishComponent } from './save-and-publish';
import {
  hasPendingChanges,
  getSaveFlowStatus,
  isCookiePolicyRequirementApproved,
} from '@src/context/selectors/app-settings';

const SaveAndPublishTranslated = translate()(SaveAndPublishComponent);

export const SaveAndPublishButton = () => {
  const store = React.useContext(AppContext);
  const liveSiteUrl = getLiveSiteUrl(store);
  const reviewRequirementApproved = isCookiePolicyRequirementApproved(store);
  const { enableAppAndSaveChanges } = store;
  return (
    <SaveAndPublishTranslated
      appEnabled={isAppEnabled(store)}
      hasPendingChanges={hasPendingChanges(store)}
      saveFlowStatus={getSaveFlowStatus(store)}
      showToast={store.showToast}
      reviewRequirementApproved={reviewRequirementApproved}
      enableAppAndSaveChanges={enableAppAndSaveChanges}
      setSaveStatus={store.setSaveStatus}
      liveSiteUrl={liveSiteUrl}
      validatePrivacyPolicy={store.validatePrivacyPolicy}
      kbLinks={getKBLinks(store)}
    />
  );
};
